import { render, staticRenderFns } from "./NewSample.vue?vue&type=template&id=74e79f2e"
import script from "./NewSample.vue?vue&type=script&lang=js"
export * from "./NewSample.vue?vue&type=script&lang=js"
import style0 from "./NewSample.vue?vue&type=style&index=0&id=74e79f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports